import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { GlobalService } from "@app/_common/global";
import { UserService } from '@services/user.service';
import { UsertrackService } from "@services/usertrack.service";
import { BehaviorSubject, filter, map } from "rxjs";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { CookieService } from 'ngx-cookie-service';
import { StockFooterComponent } from './components/stock-footer/stock-footer';
import { PipeModule } from './_pipes/pipe.module';
import { environment } from '@env/environment';
@Component({
  selector: 'app-root',
  standalone: true,
  providers: [UsertrackService, UserService, GlobalService],
  imports: [CommonModule, PipeModule, RouterOutlet, StockFooterComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  page = 'mojotimes';
  card_data: any = [];
  login_response: any = [];
  device_type = "";
  device_app_ver = "";
  device: any = "";
  isLogin = false;
  apaid: boolean = false;
  usubscription: any;
  utm_source: any = '';
  loadUserLoginSuccess = new BehaviorSubject<any>(null);
  loadUserCardSuccess = new BehaviorSubject<any>(null);
  site_url: any = environment.MOJO_SITE;
  queryParams: any = '';
  ISCLMM: boolean = false;
  constructor(private _cookie: CookieService, private router: Router, private usertrack: UsertrackService, private _users: UserService, private _global: GlobalService,) {

    let nhit = 0;
    this.ISCLMM = environment.ISCLMM;
    this.device_type = this._global.getDevicep();
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          //   setTimeout(function () {
             
          //}, 150);
          let route: ActivatedRoute = this.router.routerState.root;
          this.queryParams = route.snapshot.queryParams;
          let routeTitle = "";
          let header = false;
          let footer = false;
          this.utm_source = route.snapshot.queryParamMap.get('utm_source');

          if (this.utm_source != '' && this.utm_source != null) {
            var date = new Date();
            this._cookie.set("utm_source_track", this.utm_source, date.getTime() + 604800, '/', '.motilaloswaluat.com');
            let utm_first_src = this._cookie.get('utm_first_src');
            if (utm_first_src == '') {
              this._cookie.set("utm_first_src", this.utm_source, date.getTime() + 604800, '/', '.motilaloswaluat.com');
            }
          }
          while (route!.firstChild) {
            route = route.firstChild;
          }

          if (route.snapshot.data["title"]) {
            routeTitle = route!.snapshot.data["title"];
          }
          if(routeTitle=='mojotime'){
          window.scrollTo(0, 0);
          }
          return {
            title: routeTitle,
            header_show: header,
            footer_show: footer,
          };
        }),
      )
      .subscribe((obj: any) => {
       
        this._global.clevertabEventPush("Page View", { "PageUrl": window.location.href });
        // if (!this.ISCLMM) {
        // }
        if (obj.title) {
          this.page = obj.title;
        }
        this.onActive(this.page)
        if (nhit == 0) {
          this.loadUserLogins(this.page);
          nhit++;
        }
      });
  }

  loadUserLogins(page: any = "") {

    this._users.checklogin({}).subscribe(
      (data) => {
        //this.header_load = true;
        if (this._global.getVal(data, "code") == "200") {
          this.login_response = this._global.getVal(data, "data");
          /* MOSL - Redirect non-logged-in users to MOSL landing page */
          if (!this._global.getVal(this.login_response, 'is_login')) {
            const currentPath = window.location.pathname;
            window.location.href = this.site_url + `MOSL-Landing?redirect=${encodeURIComponent(currentPath)}`;
            return;
          }
          this._users.setLoginDetails(this.login_response);
          setTimeout(() => {
            this.loadUserLoginSuccess.next(true);
          }, 500);

          //   if (this.isLogin) {
          //this.header_load = true;
          this.usertrack.usertrack({
            page_name: this.page,
            utm_source: this.utm_source,
            userid: this._global.getVal(this.login_response, "userid")
          });
          let i = 0;
          this.usubscription = setInterval(() => {
            let ums_elem: any = document.getElementById('user_welcome_msg');
            let umsg: any = ums_elem.value;
            if (umsg != "[]" && umsg != '') {
              clearInterval(this.usubscription);
              this.card_data = JSON.parse(umsg);
              this._global.LOGIN_USER_CARD_DETAIL = this.card_data;

              this._users.setUserCardDetails(this.card_data);
              setTimeout(() => {
                this.loadUserCardSuccess.next(true);
              }, 500);
              if (this.card_data.isdisclaimer == 0) {
                window.location.href = '/mojo/disclaimernew';
              }
            } else {
              i += 1;
              if (i == 4) {
                clearInterval(this.usubscription);
                i = 0;
              }
            }
          }, 1000);
          //  }
        }
      });
  }

  onActive(page: any = '') {
    if (page != 'mojotime') {
      setTimeout(function () {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }, 150);
    }
  }
}
